import { Fragment, useEffect } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import type { LANGUAGE_OPTION_TYPES } from "~/types/language";

const OPTIONS = [
  {
    code: "eng" as const,
    label: "EN",
    nameKey: "Explore_Language_English" as const,
  },
  {
    code: "fr" as const,
    label: "FR",
    nameKey: "Explore_Language_French" as const,
  },
  {
    code: "es" as const,
    label: "ES",
    nameKey: "Explore_Language_Spanish" as const,
  },
];

const HTML_LANG: Record<LANGUAGE_OPTION_TYPES, string> = {
  eng: "en",
  fr: "fr",
  es: "es",
};

function resolveLanguage(lng: string | undefined): LANGUAGE_OPTION_TYPES {
  const code = (lng ?? "fr").split("-")[0];
  if (code === "eng" || code === "es") return code;
  return "fr";
}

export function ExploreLanguageSwitch() {
  const { i18n, t } = useTranslation();
  const active = resolveLanguage(i18n.resolvedLanguage ?? i18n.language);

  useEffect(() => {
    document.documentElement.lang = HTML_LANG[active];
  }, [active]);

  const handleChange = (code: LANGUAGE_OPTION_TYPES) => {
    if (code === active) return;
    i18n.changeLanguage(code);
    Cookies.set("language", code, { expires: 365 });
  };

  return (
    <nav className="explore-lang" aria-label={t("Explore_Language_Aria")}>
      {OPTIONS.map((option, index) => (
        <Fragment key={option.code}>
          {index > 0 ? (
            <span className="explore-lang-sep" aria-hidden>
              |
            </span>
          ) : null}
          <button
            type="button"
            className={`explore-lang-option${
              active === option.code ? " is-active" : ""
            }`}
            aria-pressed={active === option.code}
            aria-label={t(option.nameKey)}
            onClick={() => handleChange(option.code)}
          >
            {option.label}
          </button>
        </Fragment>
      ))}
    </nav>
  );
}
